module.exports = __webpack_public_path__ + "static/img/homeBg.cecfa221.png";